import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button } from "react-bootstrap";
import ReactSwitch from "react-switch";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import moments from 'moment-timezone';
import { useSelector } from 'react-redux';
import Swal from "sweetalert2";
import { postClientBookingSlotAdd, postClientBookingSlotList, patchClientBookingSlotUpdate } from "../../../Service";
import { InfinitySpin } from 'react-loader-spinner';
import { useNavigate } from "react-router-dom";

export default function StepOne() {

    const navigate = useNavigate();

    var abbrs = {
        EST : 'Eastern Standard Time',
        EDT : 'Eastern Daylight Time',
        CST : 'Central Standard Time',
        CDT : 'Central Daylight Time',
        MST : 'Mountain Standard Time',
        MDT : 'Mountain Daylight Time',
        PST : 'Pacific Standard Time',
        PDT : 'Pacific Daylight Time',
        AKST : 'Alaskan Standard Time',
        HST : 'Hawaiian Standard Time'
    };
    
    moment.fn.zoneName = function () {
        var abbr = this.zoneAbbr();
        return abbrs[abbr] || abbr;
    };

    // initial state diclaration
    const initialDayState = {allDay : true, monday : false, tuesday : false, wednesday : false, thursday : false, friday : false, saturday : false, sunday : false};
    const initialTimeState = {mondayStart : '', mondayEnd : '', tuesdayStart : '', tuesdayEnd : '', wednesdayStart : '', wednesdayEnd : '', thursdayStart : '', thursdayEnd : '', fridayStart : '', fridayEnd : '', saturdayStart : '', saturdayEnd : '', sundayStart : '', sundayEnd : ''};
    const initialBreakState = {monday : false, tuesday : false, wednesday : false, thursday : false, friday : false, saturday : false, sunday : false};
    const initialBreakTimeState = {mondayStart : '', mondayEnd : '', tuesdayStart : '', tuesdayEnd : '', wednesdayStart : '', wednesdayEnd : '', thursdayStart : '', thursdayEnd : '', fridayStart : '', fridayEnd : '', saturdayStart : '', saturdayEnd : '', sundayStart : '', sundayEnd : ''};
    
    // useState diclaration
    const [dayToggle, setDayToggle] = useState(initialDayState);
    const [dayTime, setDayTime] = useState(initialTimeState);
    const [breakToggle, setBreakToggle] = useState(initialBreakState);
    const [breakTime, setBreakTime] = useState(initialBreakTimeState);
    const [timeSlotArr, setTimeSlotArr] = useState({mondayStart : '', mondayEnd : '', tuesdayStart : '', tuesdayEnd : '', wednesdayStart : '', wednesdayEnd : '', thursdayStart : '', thursdayEnd : '', fridayStart : '', fridayEnd : '', saturdayStart : '', saturdayEnd : '', sundayStart : '', sundayEnd : ''});
    const [breakSlotArr, setbreakSlotArr] = useState({mondayStart : '', mondayEnd : '', tuesdayStart : '', tuesdayEnd : '', wednesdayStart : '', wednesdayEnd : '', thursdayStart : '', thursdayEnd : '', fridayStart : '', fridayEnd : '', saturdayStart : '', saturdayEnd : '', sundayStart : '', sundayEnd : ''});
    const [breakArr, setbreakArr] = useState({monday : '', tuesday : '', wednesday : '', thursday : '', friday : '', saturday : '', sunday : ''});
    const [dayError, setDayError] = useState({});
    const [breakError, setBreakError] = useState({});
    const [toggleError, setToggleError] = useState({});
    const [timezone, setTimezone] = useState('US/Arizona (GMT-700)');
    const [timezoneErr, setTimezoneErr] = useState('');
    const [pageDefine, setPageDefine] = useState('create');
    const [spinLoader, setSpinLoader] = useState(false);
    const [pageReload, setPageReload] = useState(false);
    const [pageLoader, setPageLoader] = useState(true);
    
    //slot error message
    const slotError = 'Your slot time is less than 30 minutes, So you can not set break';

    // get stylist data from store
    const userData =  useSelector(store => store.user['stylistuser']);

    // total available time slots 
    const timeDropDown = [{'time' : '12:15 AM', 'value' : '00:15'}, {'time' : '12:30 AM', 'value' : '00:30'}, {'time' : '12:45 AM', 'value' : '00:45'}, {'time' : '01:00 AM', 'value' : '01:00'}, {'time' : '01:15 AM', 'value' : '01:15'}, {'time' : '01:30 AM', 'value' : '01:30'}, {'time' : '01:45 AM', 'value' : '01:45'}, {'time' : '02:00 AM', 'value' : '02:00'}, {'time' : '02:15 AM', 'value' : '02:15'}, {'time' : '02:30 AM', 'value' : '02:30'}, {'time' : '02:45 AM', 'value' : '02:45'}, {'time' : '03:00 AM', 'value' : '03:00'}, {'time' : '03:15 AM', 'value' : '03:15'}, {'time' : '03:30 AM', 'value' : '03:30'}, {'time' : '03:45 AM', 'value' : '03:45'}, {'time' : '04:00 AM', 'value' : '04:00'}, {'time' : '04:15 AM', 'value' : '04:15'}, {'time' : '04:30 AM', 'value' : '04:30'}, {'time' : '04:45 AM', 'value' : '04:45'}, {'time' : '05:00 AM', 'value' : '05:00'}, {'time' : '05:15 AM', 'value' : '05:15'}, {'time' : '05:30 AM', 'value' : '05:30'}, {'time' : '05:45 AM', 'value' : '05:45'}, {'time' : '06:00 AM', 'value' : '06:00'}, {'time' : '06:15 AM', 'value' : '06:15'}, {'time' : '06:30 AM', 'value' : '06:30'}, {'time' : '06:45 AM', 'value' : '06:45'}, {'time' : '07:00 AM', 'value' : '07:00'}, {'time' : '07:15 AM', 'value' : '07:15'}, {'time' : '07:30 AM', 'value' : '07:30'}, {'time' : '07:45 AM', 'value' : '07:45'}, {'time' : '08:00 AM', 'value' : '08:00'}, {'time' : '08:15 AM', 'value' : '08:15'}, {'time' : '08:30 AM', 'value' : '08:30'}, {'time' : '08:45 AM', 'value' : '08:45'}, {'time' : '09:00 AM', 'value' : '09:00'}, {'time' : '09:15 AM', 'value' : '09:15'}, {'time' : '09:30 AM', 'value' : '09:30'}, {'time' : '09:45 AM', 'value' : '09:45'}, {'time' : '10:00 AM', 'value' : '10:00'}, {'time' : '10:15 AM', 'value' : '10:15'}, {'time' : '10:30 AM', 'value' : '10:30'}, {'time' : '10:45 AM', 'value' : '10:45'}, {'time' : '11:00 AM', 'value' : '11:00'}, {'time' : '11:15 AM', 'value' : '11:15'}, {'time' : '11:30 AM', 'value' : '11:30'}, {'time' : '11:45 AM', 'value' : '11:45'}, {'time' : '12:00 PM', 'value' : '12:00'}, {'time' : '12:15 PM', 'value' : '12:15'}, {'time' : '12:30 PM', 'value' : '12:30'}, {'time' : '12:45 PM', 'value' : '12:45'}, {'time' : '01:00 PM', 'value' : '13:00'}, {'time' : '01:15 PM', 'value' : '13:15'}, {'time' : '01:30 PM', 'value' : '13:30'}, {'time' : '01:45 PM', 'value' : '13:45'}, {'time' : '02:00 PM', 'value' : '14:00'}, {'time' : '02:15 PM', 'value' : '14:15'}, {'time' : '02:30 PM', 'value' : '14:30'}, {'time' : '02:45 PM', 'value' : '14:45'}, {'time' : '03:00 PM', 'value' : '15:00'}, {'time' : '03:15 PM', 'value' : '15:15'}, {'time' : '03:30 PM', 'value' : '15:30'}, {'time' : '03:45 PM', 'value' : '15:45'}, {'time' : '04:00 PM', 'value' : '16:00'}, {'time' : '04:15 PM', 'value' : '16:15'}, {'time' : '04:30 PM', 'value' : '16:30'}, {'time' : '04:45 PM', 'value' : '16:45'}, {'time' : '05:00 PM', 'value' : '17:00'}, {'time' : '05:15 PM', 'value' : '17:15'}, {'time' : '05:30 PM', 'value' : '17:30'}, {'time' : '05:45 PM', 'value' : '17:45'}, {'time' : '06:00 PM', 'value' : '18:00'}, {'time' : '06:15 PM', 'value' : '18:15'}, {'time' : '06:30 PM', 'value' : '18:30'}, {'time' : '06:45 PM', 'value' : '18:45'}, {'time' : '07:00 PM', 'value' : '19:00'}, {'time' : '07:15 PM', 'value' : '19:15'}, {'time' : '07:30 PM', 'value' : '19:30'}, {'time' : '07:45 PM', 'value' : '19:45'}, {'time' : '08:00 PM', 'value' : '20:00'}, {'time' : '08:15 PM', 'value' : '20:15'}, {'time' : '08:30 PM', 'value' : '20:30'}, {'time' : '08:45 PM', 'value' : '20:45'}, {'time' : '09:00 PM', 'value' : '21:00'}, {'time' : '09:15 PM', 'value' : '21:15'}, {'time' : '09:30 PM', 'value' : '21:30'}, {'time' : '09:45 PM', 'value' : '21:45'}, {'time' : '10:00 PM', 'value' : '22:00'}, {'time' : '10:15 PM', 'value' : '22:15'}, {'time' : '10:30 PM', 'value' : '22:30'}, {'time' : '10:45 PM', 'value' : '22:45'}, {'time' : '11:00 PM', 'value' : '23:00'}, {'time' : '11:15 PM', 'value' : '23:15'}, {'time' : '11:30 PM', 'value' : '23:30'}, {'time' : '11:45 PM', 'value' : '23:45'}];

    //get local time to converted time
    function getCovertedTime(time) {
        if(time){
            let getFullTime = moment().format('YYYY-MM-DD')+' '+time;
            let fullTimeWithZone = new Date(getFullTime);
            let fullTimeUtc = moment.utc(fullTimeWithZone).format();
            let getTimezone = timezone;
            let zoneSplit = getTimezone.split(' ');
            
            let getTimeWithZone = moments.tz(fullTimeUtc, zoneSplit[0]).format();
            let GetFinalTime = getTimeWithZone.split('');
            let convertedTime = GetFinalTime[11]+''+GetFinalTime[12]+':'+GetFinalTime[14]+''+GetFinalTime[15];

            return convertedTime;
        }else{
            return '';
        }
    }

    //get converted time to local time
    function getLocalTime(time, timezones) {
        if(time && timezones){
            let zonesplit = timezones.split(' ');
            const getZoneCode = moments.tz(zonesplit[0]).format('Z');
            let getLocal = moment().format('YYYY-MM-DD')+' '+time+getZoneCode;
            const fullLocalTime = new Date(getLocal);

            return moment(fullLocalTime).format('HH:mm');
        }else{
            return '';
        }
    }
    
    // day time array
    const slotTimeArray = (start, end) => {
        let newEndArr = [...timeDropDown];
        let findEndIndex = newEndArr.findIndex(x => x.value === start);
        newEndArr.splice(0, findEndIndex + 1);

        let newStartArr = [...timeDropDown];
        let reversed = newStartArr.reverse();
        let findStartIndex = newStartArr.findIndex(x => x.value === end);
        reversed.splice(0, findStartIndex + 1);
        let againReversed = newStartArr.reverse();

        let result = {endArr : newEndArr, startArr : againReversed};

        return result;
    }

    // breat time array
    const breakArray = (start, end) => {
        let newStartArr = [...timeDropDown];
        let reversed = newStartArr.reverse();
        let findStartIndex = newStartArr.findIndex(x => x.value === end);
        reversed.splice(0, findStartIndex + 1);
        let againReversed = newStartArr.reverse();
        
        let findEndIndex = againReversed.findIndex(x => x.value === start);
        againReversed.splice(0, findEndIndex + 1);
        
        return againReversed;
    }

    // if days toggle get false, the reset all the state
    const daysToggleStateReset = (day, dayStart, dayEnd) => {
        setDayTime(prevState => ({
            ...prevState,
            [dayEnd] : '', [dayStart] : ''
        }));

        setBreakTime(prevState => ({
            ...prevState,
            [dayEnd] : '', [dayStart] : ''
        }));

        setTimeSlotArr(prevState => ({
            ...prevState,
            [dayEnd] :  '', [dayStart] :  ''
        }));

        setBreakToggle(prevState => ({
            ...prevState,
            [day] :  false
        }));

        setbreakSlotArr(prevState => ({
            ...prevState,
            [dayEnd] :  '', [dayStart] :  ''
        }));

        setbreakArr(prevState => ({
            ...prevState,
            [day] :  ''
        }));
    }

    // if break toggle false, reset all states
    const breaktoggleStateReset = (day, dayStart, dayEnd) => {
        setbreakSlotArr(prevState => ({
            ...prevState,
            [dayEnd] :  '', [dayStart] :  ''
        }));

        setbreakArr(prevState => ({
            ...prevState,
            [day] :  ''
        }));

        setBreakTime(prevState => ({
            ...prevState, 
            [dayEnd] :  '', [dayStart] :  ''
        }))
    }

    // get break array by slot time
    const breakArrayBySlotTime = (getBreakArray, day, dayStart, dayEnd) => {
        setbreakArr(prevState => ({
            ...prevState,
            [day] :  getBreakArray
        }));

        
        let getMiddle = Math.floor(getBreakArray.length / 2);
        let field1 = dayStart;
        let field2 = dayEnd; 
        setBreakTime(prevState => ({
            ...prevState,
            [field1] : getBreakArray[getMiddle - 1].value, [field2] : getBreakArray[getMiddle].value 
        }))

        let newEndArr = [...getBreakArray];
        let findEndIndex = newEndArr.findIndex(x => x.value === getBreakArray[getMiddle - 1].value);
        newEndArr.splice(0, findEndIndex + 1);

        let newStartArr = [...getBreakArray];
        let reversed = newStartArr.reverse();
        let findStartIndex = newStartArr.findIndex(x => x.value === getBreakArray[getMiddle].value);
        reversed.splice(0, findStartIndex + 1);
        let againReversed = newStartArr.reverse();

        let result = {endArr : newEndArr, startArr : againReversed};

        // setbreakSlotArr(prevState => ({
        //     ...prevState,
        //     [dayStart] :  againReversed, [dayEnd] : newEndArr
        // }));
    
        setDayError(prevState => ({
            ...prevState,
            [day] : ''
        }))
    }

    
    // get break array by slot time
    const InitialbreakArrayBySlotTime = (getBreakArray, day, dayStart, dayEnd) => {
        setbreakArr(prevState => ({
            ...prevState,
            [day] :  getBreakArray
        }));

        if(getBreakArray.length > 2 ){
            let getMiddle = Math.floor(getBreakArray.length / 2);

            setDayError(prevState => ({
                ...prevState,
                [day] : ''
            }))
    
            let newEndArr = [...getBreakArray];
            let findEndIndex = newEndArr.findIndex(x => x.value === getBreakArray[getMiddle - 1].value);
            newEndArr.splice(0, findEndIndex + 1);
    
            let newStartArr = [...getBreakArray];
            let reversed = newStartArr.reverse();
            let findStartIndex = newStartArr.findIndex(x => x.value === getBreakArray[getMiddle].value);
            reversed.splice(0, findStartIndex + 1);
            let againReversed = newStartArr.reverse();
    
            let result = {endArr : newEndArr, startArr : againReversed};
    
            // setbreakSlotArr(prevState => ({
            //     ...prevState,
            //     [dayStart] :  againReversed, [dayEnd] : newEndArr
            // }));
        }

        
    }


    // timezone handle change 
    const timezoneHandleChange = (e) => {
        setTimezone(e.target.value);
    }

    // days toggle button onChange 
    const dayToggleHandleChange = (e, day) => {
        const value = e;
        const field = day;
        setDayToggle(prevState => ({
          ...prevState,
          [field] : value  
        }));

        if(value == true){
            let getDayTimeArray = slotTimeArray('09:00', '18:00');

            if(day === 'monday'){
                const startField = 'mondayStart';
                const endField = 'mondayEnd';

                setDayTime(prevState => ({
                    ...prevState,
                    [startField] : '09:00', [endField] : '18:00'
                }));

                setTimeSlotArr(prevState => ({
                    ...prevState,
                    mondayEnd :  getDayTimeArray.endArr, mondayStart :  getDayTimeArray.startArr
                }));
            }

            if(day === 'tuesday'){
                const startField = 'tuesdayStart';
                const endField = 'tuesdayEnd';

                setDayTime(prevState => ({
                    ...prevState,
                    [startField] : '09:00', [endField] : '18:00'
                }));

                setTimeSlotArr(prevState => ({
                    ...prevState,
                    tuesdayEnd :  getDayTimeArray.endArr, tuesdayStart :  getDayTimeArray.startArr
                }));
            }

            if(day === 'wednesday'){
                const startField = 'wednesdayStart';
                const endField = 'wednesdayEnd';

                setDayTime(prevState => ({
                    ...prevState,
                    [startField] : '09:00', [endField] : '18:00'
                }));

                setTimeSlotArr(prevState => ({
                    ...prevState,
                    wednesdayEnd :  getDayTimeArray.endArr, wednesdayStart :  getDayTimeArray.startArr
                }));
            }

            if(day === 'thursday'){
                const startField = 'thursdayStart';
                const endField = 'thursdayEnd';

                setDayTime(prevState => ({
                    ...prevState,
                    [startField] : '09:00', [endField] : '18:00'
                }));

                setTimeSlotArr(prevState => ({
                    ...prevState,
                    thursdayEnd :  getDayTimeArray.endArr, thursdayStart :  getDayTimeArray.startArr
                }));
            }

            if(day === 'friday'){
                const startField = 'fridayStart';
                const endField = 'fridayEnd';

                setDayTime(prevState => ({
                    ...prevState,
                    [startField] : '09:00', [endField] : '18:00'
                }));

                setTimeSlotArr(prevState => ({
                    ...prevState,
                    fridayEnd :  getDayTimeArray.endArr, fridayStart :  getDayTimeArray.startArr
                }));
            }

            if(day === 'saturday'){
                const startField = 'saturdayStart';
                const endField = 'saturdayEnd';

                setDayTime(prevState => ({
                    ...prevState,
                    [startField] : '09:00', [endField] : '18:00'
                }));

                setTimeSlotArr(prevState => ({
                    ...prevState,
                    saturdayEnd :  getDayTimeArray.endArr, saturdayStart :  getDayTimeArray.startArr
                }));
            }

            if(day === 'sunday'){
                const startField = 'sundayStart';
                const endField = 'sundayEnd';

                setDayTime(prevState => ({
                    ...prevState,
                    [startField] : '09:00', [endField] : '18:00'
                }));

                setTimeSlotArr(prevState => ({
                    ...prevState,
                    sundayEnd :  getDayTimeArray.endArr, sundayStart :  getDayTimeArray.startArr
                }));
            }
        }else{
            setDayError(prevState => ({
                ...prevState,
                [field] : ''
            }))

            if(day === 'monday'){
                daysToggleStateReset('monday', 'mondayStart', 'mondayEnd');
            }

            if(day === 'tuesday'){
                daysToggleStateReset('tuesday', 'tuesdayStart', 'tuesdayEnd');
            }

            if(day === 'wednesday'){
                daysToggleStateReset('wednesday', 'wednesdayStart', 'wednesdayEnd');
            }

            if(day === 'thursday'){
                daysToggleStateReset('thursday', 'thursdayStart', 'thursdayEnd');
            }

            if(day === 'friday'){
                daysToggleStateReset('friday', 'fridayStart', 'fridayEnd');
            }

            if(day === 'saturday'){
                daysToggleStateReset('saturday', 'saturdayStart', 'saturdayEnd');
            }

            if(day === 'sunday'){
                daysToggleStateReset('sunday', 'sundayStart', 'sundayEnd');
            }
        }
    }

    // total time slots onchange
    const timeHandleChange = (e) => {
        const value=e.target.value;
        const field=e.target.name;
        setDayTime(prevState => ({
            ...prevState,
            [field] : value
        }));

        let newEndArr = [...timeDropDown];
        let findEndIndex = newEndArr.findIndex(x => x.value === value);
        newEndArr.splice(0, findEndIndex + 1);

        let newStartArr = [...timeDropDown];
        let reversed = newStartArr.reverse();
        let findStartIndex = newStartArr.findIndex(x => x.value === value);
        reversed.splice(0, findStartIndex + 1);
        let againReversed = newStartArr.reverse();

        if(field === 'mondayStart'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'mondayEnd' :  newEndArr
            }));

            let getBreakArray = breakArray(value, dayTime.mondayEnd);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'monday', 'mondayStart', 'mondayEnd');
            }else{
                if(breakToggle.monday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        monday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        monday :  false  
                    }));
                }
            }
        }

        if(field === 'mondayEnd'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'mondayStart' :  againReversed
            }))

            let getBreakArray = breakArray(dayTime.mondayStart, value);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'monday', 'mondayStart', 'mondayEnd');
            }else{
                if(breakToggle.monday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        monday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        monday :  false  
                    }));
                }
            }
        }

        if(field === 'tuesdayStart'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'tuesdayEnd' :  newEndArr
            }));

            let getBreakArray = breakArray(value, dayTime.tuesdayEnd);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'tuesday', 'tuesdayStart', 'tuesdayEnd');
            }else{
                if(breakToggle.tuesday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        tuesday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        tuesday :  false  
                    }));
                }
            }
        }

        if(field === 'tuesdayEnd'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'tuesdayStart' :  againReversed
            }))

            let getBreakArray = breakArray(dayTime.tuesdayStart, value);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'tuesday', 'tuesdayStart', 'tuesdayEnd');
            }else{
                if(breakToggle.tuesday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        tuesday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        tuesday :  false  
                    }));
                }
            }
        }

        if(field === 'wednesdayStart'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'wednesdayEnd' :  newEndArr
            }));

            let getBreakArray = breakArray(value, dayTime.wednesdayEnd);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'wednesday', 'wednesdayStart', 'wednesdayEnd');
            }else{
                if(breakToggle.wednesday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        wednesday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        wednesday :  false  
                    }));
                }
            }
        }

        if(field === 'wednesdayEnd'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'wednesdayStart' :  againReversed
            }))

            let getBreakArray = breakArray(dayTime.wednesdayStart, value);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'wednesday', 'wednesdayStart', 'wednesdayEnd');
            }else{
                if(breakToggle.wednesday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        wednesday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        wednesday :  false  
                    }));
                }
            }
        }

        if(field === 'thursdayStart'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'thursdayEnd' :  newEndArr
            }));

            let getBreakArray = breakArray(value, dayTime.thursdayEnd);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'thursday', 'thursdayStart', 'thursdayEnd');
            }else{
                if(breakToggle.thursday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        thursday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        thursday :  false  
                    }));
                }
            }
        }

        if(field === 'thursdayEnd'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'thursdayStart' :  againReversed
            }))

            let getBreakArray = breakArray(dayTime.thursdayStart, value);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'thursday', 'thursdayStart', 'thursdayEnd');
            }else{
                if(breakToggle.thursday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        thursday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        thursday :  false  
                    }));
                }
            }
        }

        if(field === 'fridayStart'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'fridayEnd' :  newEndArr
            }));

            let getBreakArray = breakArray(value, dayTime.fridayEnd);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'friday', 'fridayStart', 'fridayEnd');
            }else{
                if(breakToggle.friday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        friday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        friday :  false  
                    }));
                }
            }
        }

        if(field === 'fridayEnd'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'fridayStart' :  againReversed
            }))

            let getBreakArray = breakArray(dayTime.fridayStart, value);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'friday', 'fridayStart', 'fridayEnd');
            }else{
                if(breakToggle.friday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        friday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        friday :  false  
                    }));
                }
            }
        }

        if(field === 'saturdayStart'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'saturdayEnd' :  newEndArr
            }));

            let getBreakArray = breakArray(value, dayTime.saturdayEnd);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'saturday', 'saturdayStart', 'saturdayEnd');
            }else{
                if(breakToggle.saturday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        saturday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        saturday :  false  
                    }));
                }
            }
        }

        if(field === 'saturdayEnd'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'saturdayStart' :  againReversed
            }))

            let getBreakArray = breakArray(dayTime.saturdayStart, value);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'saturday', 'saturdayStart', 'saturdayEnd');
            }else{
                if(breakToggle.saturday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        saturday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        saturday :  false  
                    }));
                }
            }
        }

        if(field === 'sundayStart'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'sundayEnd' :  newEndArr
            }));

            let getBreakArray = breakArray(value, dayTime.sundayEnd);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'sunday', 'sundayStart', 'sundayEnd');
            }else{
                if(breakToggle.sunday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        sunday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        sunday :  false  
                    }));
                }
            }
        }

        if(field === 'sundayEnd'){
            setTimeSlotArr(prevState => ({
                ...prevState,
                'sundayStart' :  againReversed
            }))

            let getBreakArray = breakArray(dayTime.sundayStart, value);

            if(getBreakArray.length > 1){
                breakArrayBySlotTime(getBreakArray, 'sunday', 'sundayStart', 'sundayEnd');
            }else{
                if(breakToggle.sunday == true){
                    setDayError(prevState => ({
                        ...prevState,
                        sunday : slotError
                    }))
    
                    setBreakToggle(prevState => ({
                        ...prevState,
                        sunday :  false  
                    }));
                }
            }
        }
    }

    // add break and remove break handler 
    const BreakHandler = (status, day) => {
        if(status == false){

            const value=status;
            const field=day;
            setBreakToggle(prevState => ({
            ...prevState,
            [field]:  value  }));

            if(field == 'monday'){
                breaktoggleStateReset('monday', 'mondayStart', 'mondayEnd');
            }

            if(field == 'tuesday'){
                breaktoggleStateReset('tuesday', 'tuesdayStart', 'tuesdayEnd');
            }

            if(field == 'wednesday'){
                breaktoggleStateReset('wednesday', 'wednesdayStart', 'wednesdayEnd');
            }

            if(field == 'thursday'){
                breaktoggleStateReset('thursday', 'thursdayStart', 'thursdayEnd');
            }

            if(field == 'friday'){
                breaktoggleStateReset('friday', 'fridayStart', 'fridayEnd');
            }

            if(field == 'saturday'){
                breaktoggleStateReset('saturday', 'saturdayStart', 'saturdayEnd');
            }

            if(field == 'sunday'){
                breaktoggleStateReset('sunday', 'sundayStart', 'sundayEnd');
            }

        }else{

            if(day == 'monday'){
                setDayError(prevState => ({
                    ...prevState,
                    monday : ''
                }))

                let breakStart = dayTime.mondayStart;
                let breakEnd = dayTime.mondayEnd;

                let getBreakArray = breakArray(breakStart, breakEnd);

                if(getBreakArray.length > 1){
                    breakArrayBySlotTime(getBreakArray, 'monday', 'mondayStart', 'mondayEnd');

                    setBreakToggle(prevState => ({
                    ...prevState,
                    [day]:  status  }));
                }else{
                    setDayError(prevState => ({
                        ...prevState,
                        monday : slotError
                    }))
                }
            }

            if(day == 'tuesday'){
                setDayError(prevState => ({
                    ...prevState,
                    tuesday : ''
                }))

                let breakStart = dayTime.tuesdayStart;
                let breakEnd = dayTime.tuesdayEnd;

                let getBreakArray = breakArray(breakStart, breakEnd);

                if(getBreakArray.length > 1){
                    breakArrayBySlotTime(getBreakArray, 'tuesday', 'tuesdayStart', 'tuesdayEnd');

                    setBreakToggle(prevState => ({
                        ...prevState,
                        [day]:  status  }));
                }else{
                    setDayError(prevState => ({
                        ...prevState,
                        tuesday : slotError
                    }))
                }  
            }

            if(day == 'wednesday'){
                setDayError(prevState => ({
                    ...prevState,
                    wednesday : ''
                }))

                let breakStart = dayTime.wednesdayStart;
                let breakEnd = dayTime.wednesdayEnd;

                let getBreakArray = breakArray(breakStart, breakEnd);

                if(getBreakArray.length > 1){
                    breakArrayBySlotTime(getBreakArray, 'wednesday', 'wednesdayStart', 'wednesdayEnd');

                    setBreakToggle(prevState => ({
                        ...prevState,
                        [day]:  status  }));
                }else{
                    setDayError(prevState => ({
                        ...prevState,
                        wednesday : slotError
                    }))
                }  
            }

            if(day == 'thursday'){
                setDayError(prevState => ({
                    ...prevState,
                    thursday : ''
                }))

                let breakStart = dayTime.thursdayStart;
                let breakEnd = dayTime.thursdayEnd;

                let getBreakArray = breakArray(breakStart, breakEnd);

                if(getBreakArray.length > 1){
                    breakArrayBySlotTime(getBreakArray, 'thursday', 'thursdayStart', 'thursdayEnd');

                    setBreakToggle(prevState => ({
                        ...prevState,
                        [day]:  status  }));
                }else{
                    setDayError(prevState => ({
                        ...prevState,
                        thursday : slotError
                    }))
                }  
            }

            if(day == 'friday'){
                setDayError(prevState => ({
                    ...prevState,
                    friday : ''
                }))

                let breakStart = dayTime.fridayStart;
                let breakEnd = dayTime.fridayEnd;

                let getBreakArray = breakArray(breakStart, breakEnd);

                if(getBreakArray.length > 1){
                    breakArrayBySlotTime(getBreakArray, 'friday', 'fridayStart', 'fridayEnd');

                    setBreakToggle(prevState => ({
                        ...prevState,
                        [day]:  status  }));
                }else{
                    setDayError(prevState => ({
                        ...prevState,
                        friday : slotError
                    }))
                }  
            }

            if(day == 'saturday'){
                setDayError(prevState => ({
                    ...prevState,
                    saturday : ''
                }))

                let breakStart = dayTime.saturdayStart;
                let breakEnd = dayTime.saturdayEnd;

                let getBreakArray = breakArray(breakStart, breakEnd);

                if(getBreakArray.length > 1){
                    breakArrayBySlotTime(getBreakArray, 'saturday', 'saturdayStart', 'saturdayEnd');

                    setBreakToggle(prevState => ({
                        ...prevState,
                        [day]:  status  }));
                }else{
                    setDayError(prevState => ({
                        ...prevState,
                        saturday : slotError
                    }))
                }  
            }

            if(day == 'sunday'){
                setDayError(prevState => ({
                    ...prevState,
                    sunday : ''
                }))

                let breakStart = dayTime.sundayStart;
                let breakEnd = dayTime.sundayEnd;

                let getBreakArray = breakArray(breakStart, breakEnd);

                if(getBreakArray.length > 1){
                    breakArrayBySlotTime(getBreakArray, 'sunday', 'sundayStart', 'sundayEnd');

                    setBreakToggle(prevState => ({
                        ...prevState,
                        [day]:  status  }));
                }else{
                    setDayError(prevState => ({
                        ...prevState,
                        sunday : slotError
                    }))
                }  
            }
        }
    }

    // break fields handle Change
    const breakHandleChange = (e) => {
        const value=e.target.value;
        const field=e.target.name;
        setBreakTime(prevState => ({
            ...prevState,
            [field] : value
        }));

        // if(field === 'mondayStart'){
        //     let newEndArr = [...breakArr.monday];
        //     let findEndIndex = newEndArr.findIndex(x => x.value === value);
        //     newEndArr.splice(0, findEndIndex + 1);

        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'mondayEnd' :  newEndArr
        //     }));
        // }

        // if(field === 'mondayEnd'){
        //     let newStartArr = [...breakArr.monday];
        //     let reversed = newStartArr.reverse();
        //     let findStartIndex = newStartArr.findIndex(x => x.value === value);
        //     reversed.splice(0, findStartIndex + 1);
        //     let againReversed = newStartArr.reverse();

        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'mondayStart' :  againReversed
        //     }))
        // }

        // if(field === 'tuesdayStart'){
        //     let newEndArr = [...breakArr.tuesday];
        //     let findEndIndex = newEndArr.findIndex(x => x.value === value);
        //     newEndArr.splice(0, findEndIndex + 1);

        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'tuesdayEnd' :  newEndArr
        //     }));
        // }

        // if(field === 'tuesdayEnd'){
        //     let newStartArr = [...breakArr.tuesday];
        //     let reversed = newStartArr.reverse();
        //     let findStartIndex = newStartArr.findIndex(x => x.value === value);
        //     reversed.splice(0, findStartIndex + 1);
        //     let againReversed = newStartArr.reverse();
            
        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'tuesdayStart' :  againReversed
        //     }))
        // }

        // if(field === 'wednesdayStart'){
        //     let newEndArr = [...breakArr.wednesday];
        //     let findEndIndex = newEndArr.findIndex(x => x.value === value);
        //     newEndArr.splice(0, findEndIndex + 1);

        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'wednesdayEnd' :  newEndArr
        //     }));
        // }

        // if(field === 'wednesdayEnd'){
        //     let newStartArr = [...breakArr.wednesday];
        //     let reversed = newStartArr.reverse();
        //     let findStartIndex = newStartArr.findIndex(x => x.value === value);
        //     reversed.splice(0, findStartIndex + 1);
        //     let againReversed = newStartArr.reverse();
            
        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'wednesdayStart' :  againReversed
        //     }))
        // }

        // if(field === 'thursdayStart'){
        //     let newEndArr = [...breakArr.thursday];
        //     let findEndIndex = newEndArr.findIndex(x => x.value === value);
        //     newEndArr.splice(0, findEndIndex + 1);

        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'thursdayEnd' :  newEndArr
        //     }));
        // }

        // if(field === 'thursdayEnd'){
        //     let newStartArr = [...breakArr.thursday];
        //     let reversed = newStartArr.reverse();
        //     let findStartIndex = newStartArr.findIndex(x => x.value === value);
        //     reversed.splice(0, findStartIndex + 1);
        //     let againReversed = newStartArr.reverse();
            
        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'thursdayStart' :  againReversed
        //     }))
        // }

        // if(field === 'fridayStart'){
        //     let newEndArr = [...breakArr.friday];
        //     let findEndIndex = newEndArr.findIndex(x => x.value === value);
        //     newEndArr.splice(0, findEndIndex + 1);

        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'fridayEnd' :  newEndArr
        //     }));
        // }

        // if(field === 'fridayEnd'){
        //     let newStartArr = [...breakArr.friday];
        //     let reversed = newStartArr.reverse();
        //     let findStartIndex = newStartArr.findIndex(x => x.value === value);
        //     reversed.splice(0, findStartIndex + 1);
        //     let againReversed = newStartArr.reverse();
            
        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'fridayStart' :  againReversed
        //     }))
        // }

        // if(field === 'saturdayStart'){
        //     let newEndArr = [...breakArr.saturday];
        //     let findEndIndex = newEndArr.findIndex(x => x.value === value);
        //     newEndArr.splice(0, findEndIndex + 1);

        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'saturdayEnd' :  newEndArr
        //     }));
        // }

        // if(field === 'saturdayEnd'){
        //     let newStartArr = [...breakArr.saturday];
        //     let reversed = newStartArr.reverse();
        //     let findStartIndex = newStartArr.findIndex(x => x.value === value);
        //     reversed.splice(0, findStartIndex + 1);
        //     let againReversed = newStartArr.reverse();
            
        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'saturdayStart' :  againReversed
        //     }))
        // }

        // if(field === 'sundayStart'){
        //     let newEndArr = [...breakArr.sunday];
        //     let findEndIndex = newEndArr.findIndex(x => x.value === value);
        //     newEndArr.splice(0, findEndIndex + 1);

        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'sundayEnd' :  newEndArr
        //     }));
        // }

        // if(field === 'sundayEnd'){
        //     let newStartArr = [...breakArr.sunday];
        //     let reversed = newStartArr.reverse();
        //     let findStartIndex = newStartArr.findIndex(x => x.value === value);
        //     reversed.splice(0, findStartIndex + 1);
        //     let againReversed = newStartArr.reverse();
            
        //     setbreakSlotArr(prevState => ({
        //         ...prevState,
        //         'sundayStart' :  againReversed
        //     }))
        // }
    }

    // form handle submit
    const handleSubmit = (e) => {
        e.preventDefault();

        if(!userData.shopId){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please complete your business shop setup before setting your availability.',
                showConfirmButton: false,
                timer: 3000
            });
            navigate('/stylist/select-business');
            return;
        }

        const dayToggleError = dayToggleValidate(dayToggle);
        setToggleError(dayToggleError)
        const timeSlotError = timeSlotValidate(dayTime);
        setDayError(timeSlotError);
        const breakTimeError = breakTimeValidate(breakTime);
        setBreakError(breakTimeError);
        const timezoneError = timezoneValidate(timezone);
        setTimezoneErr(timezoneError);

        if(timeSlotError.status && breakTimeError.status && timezoneError.status && dayToggleError.status){
            let convertedDayTime =  {
                'mondayStartDT' : dayTime.mondayStart, 
                'mondayEndDT' : dayTime.mondayEnd, 
                'tuesdayStartDT' : dayTime.tuesdayStart, 
                'tuesdayEndDT' : dayTime.tuesdayEnd, 
                'wednesdayStartDT' : dayTime.wednesdayStart, 
                'wednesdayEndDT' : dayTime.wednesdayEnd, 
                'thursdayStartDT' : dayTime.thursdayStart, 
                'thursdayEndDT' : dayTime.thursdayEnd, 
                'fridayStartDT' : dayTime.fridayStart, 
                'fridayEndDT' : dayTime.fridayEnd,
                'saturdayStartDT' : dayTime.saturdayStart, 
                'saturdayEndDT' : dayTime.saturdayEnd, 
                'sundayStartDT' : dayTime.sundayStart, 
                'sundayEndDT' : dayTime.sundayEnd
            };
            let convertedbreakTime =  {
                'mondayStartDT' : breakToggle.monday ? breakTime.mondayStart : '', 
                'mondayEndDT' : breakToggle.monday ? breakTime.mondayEnd : '', 
                'tuesdayStartDT' : breakToggle.tuesday ? breakTime.tuesdayStart : '', 
                'tuesdayEndDT' : breakToggle.tuesday ? breakTime.tuesdayEnd : '', 
                'wednesdayStartDT' : breakToggle.wednesday ? breakTime.wednesdayStart : '', 
                'wednesdayEndDT' : breakToggle.wednesday ? breakTime.wednesdayEnd : '', 
                'thursdayStartDT' : breakToggle.thursday ? breakTime.thursdayStart : '', 
                'thursdayEndDT' : breakToggle.thursday ? breakTime.thursdayEnd : '', 
                'fridayStartDT' : breakToggle.friday ? breakTime.fridayStart : '', 
                'fridayEndDT' : breakToggle.friday ? breakTime.fridayEnd : '',
                'saturdayStartDT' : breakToggle.saturday ? breakTime.saturdayStart : '', 
                'saturdayEndDT' : breakToggle.saturday ? breakTime.saturdayEnd : '', 
                'sundayStartDT' : breakToggle.sunday ? breakTime.sundayStart : '', 
                'sundayEndDT' : breakToggle.sunday ? breakTime.sundayEnd : ''
            };
            let slotData = {'clientId' : userData.clientId, 'shopId' :  userData.shopId, 'timeZone' : timezone, 'statusOfTheDays' : dayToggle, 'breakStatusOfTheDays' : breakToggle, 'daysTimeSlot' : convertedDayTime, 'daysBreakTimeSlot' : convertedbreakTime}

            if(pageDefine == 'create'){
                postClientBookingSlotAdd(slotData).then(res => slotAddResponse(res));
                setSpinLoader(true);
            }else if(pageDefine == 'update'){
                patchClientBookingSlotUpdate(slotData).then(res => slotAddResponse(res));
                setSpinLoader(true);
            }
        }else{
            window.scrollTo(0, 0)
        }
    }

    // after submit handle response
    const slotAddResponse = (res) => {
        if(res.data.statusCode === 200){
            navigate('/stylist/step-II');
            setSpinLoader(false);
            setPageReload(prevState => !prevState);
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: res.data.statusMessage,
                showConfirmButton: false,
                timer: 3000
            });
            setSpinLoader(false);
            setPageReload(prevState => !prevState);
        }
    }

    // dayToggle validation
    const dayToggleValidate = (values) => {
        const errors = {};
        errors.status = true;

        if(values.monday === false && values.tuesday === false && values.wednesday === false && values.thursday === false && values.friday === false && values.saturday === false && values.sunday === false){
            errors.checkToggle = 'Please setup your availability';
            errors.status = false;
        }

        return errors;
    }

    // day time slot validation
    const timeSlotValidate = (value) => {
        const errors = {};
        errors.status = true;

        if(dayToggle.monday == true){
            if(!value.mondayStart || !value.mondayEnd){
                errors.monday = 'Available time is required';
                errors.status = false;
            }
        }
        if(dayToggle.tuesday == true){
            if(!value.tuesdayStart || !value.tuesdayEnd){
                errors.tuesday = 'Available time is required';
                errors.status = false;
            }
        }
        if(dayToggle.wednesday == true){
            if(!value.wednesdayStart || !value.wednesdayEnd){
                errors.wednesday = 'Available time is required';
                errors.status = false;
            }
        }
        if(dayToggle.thursday == true){
            if(!value.thursdayStart || !value.thursdayEnd){
                errors.thursday = 'Available time is required';
                errors.status = false;
            }
        }
        if(dayToggle.friday == true){
            if(!value.fridayStart || !value.fridayEnd){
                errors.friday = 'Available time is required';
                errors.status = false;
            }
        }
        if(dayToggle.saturday == true){
            if(!value.saturdayStart || !value.saturdayEnd){
                errors.saturday = 'Available time is required';
                errors.status = false;
            }
        }
        if(dayToggle.sunday == true){
            if(!value.sundayStart || !value.sundayEnd){
                errors.sunday = 'Available time is required';
                errors.status = false;
            }
        }

        return errors;
    }

    const breakValidationCheck = (time) => {
        let newEndArr = [...timeDropDown];
        let findIndex = newEndArr.findIndex(x => x.value === time);
        return findIndex;
    }

    // break time validation
    const breakTimeValidate = (value) => {
        const errors = {};
        errors.status = true;

        if(breakToggle.monday == true){
            if(!value.mondayStart || !value.mondayEnd){
                errors.monday = 'Break time is required';
                errors.status = false;
            }
            if(value.mondayStart && value.mondayEnd){
                let getStart = breakValidationCheck(value.mondayStart);
                let getEnd = breakValidationCheck(value.mondayEnd);
                if(getStart >= getEnd){
                    errors.monday = 'Enter valid break time';
                    errors.status = false;
                }
            }
        }
        if(breakToggle.tuesday == true){
            if(!value.tuesdayStart || !value.tuesdayEnd){
                errors.tuesday = 'Break time is required';
                errors.status = false;
            }
            if(value.tuesdayStart && value.tuesdayEnd){
                let getStart = breakValidationCheck(value.tuesdayStart);
                let getEnd = breakValidationCheck(value.tuesdayEnd);
                if(getStart >= getEnd){
                    errors.tuesday = 'Enter valid break time';
                    errors.status = false;
                }
            }
        }
        if(breakToggle.wednesday == true){
            if(!value.wednesdayStart || !value.wednesdayEnd){
                errors.wednesday = 'Break time is required';
                errors.status = false;
            }
            if(value.wednesdayStart && value.wednesdayEnd){
                let getStart = breakValidationCheck(value.wednesdayStart);
                let getEnd = breakValidationCheck(value.wednesdayEnd);
                if(getStart >= getEnd){
                    errors.wednesday = 'Enter valid break time';
                    errors.status = false;
                }
            }
        }
        if(breakToggle.thursday == true){
            if(!value.thursdayStart || !value.thursdayEnd){
                errors.thursday = 'Break time is required';
                errors.status = false;
            }
            if(value.thursdayStart && value.thursdayEnd){
                let getStart = breakValidationCheck(value.thursdayStart);
                let getEnd = breakValidationCheck(value.thursdayEnd);
                if(getStart >= getEnd){
                    errors.thursday = 'Enter valid break time';
                    errors.status = false;
                }
            }
        }
        if(breakToggle.friday == true){
            if(!value.fridayStart || !value.fridayEnd){
                errors.friday = 'Break time is required';
                errors.status = false;
            }
            if(value.fridayStart && value.fridayEnd){
                let getStart = breakValidationCheck(value.fridayStart);
                let getEnd = breakValidationCheck(value.fridayEnd);
                if(getStart >= getEnd){
                    errors.friday = 'Enter valid break time';
                    errors.status = false;
                }
            }
        }
        if(breakToggle.saturday == true){
            if(!value.saturdayStart || !value.saturdayEnd){
                errors.saturday = 'Break time is required';
                errors.status = false;
            }
            if(value.saturdayStart && value.saturdayEnd){
                let getStart = breakValidationCheck(value.saturdayStart);
                let getEnd = breakValidationCheck(value.saturdayEnd);
                if(getStart >= getEnd){
                    errors.saturday = 'Enter valid break time';
                    errors.status = false;
                }
            }
        }
        if(breakToggle.sunday == true){
            if(!value.sundayStart || !value.sundayEnd){
                errors.sunday = 'Break time is required';
                errors.status = false;
            }
            if(value.sundayStart && value.sundayEnd){
                let getStart = breakValidationCheck(value.sundayStart);
                let getEnd = breakValidationCheck(value.sundayEnd);
                if(getStart >= getEnd){
                    errors.sunday = 'Enter valid break time';
                    errors.status = false;
                }
            }
        }

        return errors;
    }

    // timezone validation
    const timezoneValidate = (value) => {
        const errors = {};
        errors.status = true;
        
        if(!value){
            errors.timezone = 'timezone is required';
            errors.status = false;
        }

        return errors;
    }

    // get slot times data from api by client id
    useEffect(() => {
        let stylistParams = { "clientId": userData.clientId };
        postClientBookingSlotList(stylistParams).then(res => initalAPIResponse(res));
        setPageLoader(true);
    }, [pageReload]);

    // useEffect api response handle
    const initalAPIResponse = (res) => {
        if(res.data.statusCode == 200){
            if(res.data.clientId != 0){
                navigate('/stylist/step-II');
                setPageLoader(false);
                setPageDefine('update');
                setTimezone(res.data.timeZone);
                let resDayToggle = res.data.statusOfTheDays;
                setDayToggle({allDay : resDayToggle.allDay, monday : resDayToggle.monday, tuesday : resDayToggle.tuesday, wednesday : resDayToggle.wednesday, thursday : resDayToggle.thursday, friday : resDayToggle.friday, saturday : resDayToggle.saturday, sunday : resDayToggle.sunday});
                let resBreakToggle = res.data.breakStatusOfTheDays;
                setBreakToggle({monday : resBreakToggle.monday, tuesday : resBreakToggle.tuesday, wednesday : resBreakToggle.wednesday, thursday : resBreakToggle.thursday, friday : resBreakToggle.friday, saturday : resBreakToggle.saturday, sunday : resBreakToggle.sunday});
                let resDayTime = res.data.daysTimeSlot;
                setDayTime({
                    mondayStart : resDayTime.mondayStartDT != null ? resDayTime.mondayStartDT : '',
                    mondayEnd : resDayTime.mondayEndDT != null ? resDayTime.mondayEndDT : '', 
                    tuesdayStart : resDayTime.tuesdayStartDT !== null ? resDayTime.tuesdayStartDT : '', 
                    tuesdayEnd : resDayTime.tuesdayEndDT !== null ? resDayTime.tuesdayEndDT : '', 
                    wednesdayStart : resDayTime.wednesdayStartDT !== null ? resDayTime.wednesdayStartDT : '', 
                    wednesdayEnd : resDayTime.wednesdayEndDT !== null ? resDayTime.wednesdayEndDT : '', 
                    thursdayStart : resDayTime.thursdayStartDT !== null ? resDayTime.thursdayStartDT : '', 
                    thursdayEnd : resDayTime.thursdayEndDT !== null ? resDayTime.thursdayEndDT : '', 
                    fridayStart : resDayTime.fridayStartDT !== null ? resDayTime.fridayStartDT : '', 
                    fridayEnd : resDayTime.fridayEndDT !== null ? resDayTime.fridayEndDT : '', 
                    saturdayStart : resDayTime.saturdayStartDT !== null ? resDayTime.saturdayStartDT : '', 
                    saturdayEnd : resDayTime.saturdayEndDT !== null ? resDayTime.saturdayEndDT : '', 
                    sundayStart : resDayTime.sundayStartDT !== null ? resDayTime.sundayStartDT : '', 
                    sundayEnd : resDayTime.sundayEndDT !== null ? resDayTime.sundayEndDT : ''
                });
                let resBreakTime = res.data.daysBreakTimeSlot;
                setBreakTime({
                    mondayStart : resBreakTime.mondayStartDT !== null ? resBreakTime.mondayStartDT : '',
                    mondayEnd : resBreakTime.mondayEndDT !== null ? resBreakTime.mondayEndDT : '', 
                    tuesdayStart : resBreakTime.tuesdayStartDT != null ? resBreakTime.tuesdayStartDT : '', 
                    tuesdayEnd : resBreakTime.tuesdayEndDT != null ? resBreakTime.tuesdayEndDT : '', 
                    wednesdayStart : resBreakTime.wednesdayStartDT !== null ? resBreakTime.wednesdayStartDT : '', 
                    wednesdayEnd : resBreakTime.wednesdayEndDT !== null ? resBreakTime.wednesdayEndDT : '', 
                    thursdayStart : resBreakTime.thursdayStartDT !== null ? resBreakTime.thursdayStartDT : '', 
                    thursdayEnd : resBreakTime.thursdayEndDT !== null ? resBreakTime.thursdayEndDT : '', 
                    fridayStart : resBreakTime.fridayStartDT !== null ? resBreakTime.fridayStartDT : '', 
                    fridayEnd : resBreakTime.fridayEndDT !== null ? resBreakTime.fridayEndDT : '', 
                    saturdayStart : resBreakTime.saturdayStartDT !== null ? resBreakTime.saturdayStartDT : '', 
                    saturdayEnd : resBreakTime.saturdayEndDT !== null ? resBreakTime.saturdayEndDT : '', 
                    sundayStart : resBreakTime.sundayStartDT !== null ? resBreakTime.sundayStartDT : '', 
                    sundayEnd : resBreakTime.sundayEndDT !== null ? resBreakTime.sundayEndDT : ''
                });

                if(resDayToggle.monday == true){
                    let getDayTimeArray = slotTimeArray(resDayTime.mondayStartDT, res.data.timeZone, resDayTime.mondayEndDT, res.data.timeZone);

                    setTimeSlotArr(prevState => ({
                        ...prevState,
                        mondayEnd :  getDayTimeArray.endArr, mondayStart :  getDayTimeArray.startArr
                    }));
                }

                if(resDayToggle.tuesday == true){
                    let getDayTimeArray = slotTimeArray(resDayTime.tuesdayStartDT, res.data.timeZone, resDayTime.tuesdayEndDT, res.data.timeZone);

                    setTimeSlotArr(prevState => ({
                        ...prevState,
                        tuesdayEnd :  getDayTimeArray.endArr, tuesdayStart :  getDayTimeArray.startArr
                    }));
                }

                if(resDayToggle.wednesday == true){
                    let getDayTimeArray = slotTimeArray(resDayTime.wednesdayStartDT, res.data.timeZone, resDayTime.wednesdayEndDT, res.data.timeZone);

                    setTimeSlotArr(prevState => ({
                        ...prevState,
                        wednesdayEnd :  getDayTimeArray.endArr, wednesdayStart :  getDayTimeArray.startArr
                    }));
                }

                if(resDayToggle.thursday == true){
                    let getDayTimeArray = slotTimeArray(resDayTime.thursdayStartDT, res.data.timeZone, resDayTime.thursdayEndDT, res.data.timeZone);

                    setTimeSlotArr(prevState => ({
                        ...prevState,
                        thursdayEnd :  getDayTimeArray.endArr, thursdayStart :  getDayTimeArray.startArr
                    }));
                }

                if(resDayToggle.friday == true){
                    let getDayTimeArray = slotTimeArray(resDayTime.fridayStartDT, res.data.timeZone, resDayTime.fridayEndDT, res.data.timeZone);

                    setTimeSlotArr(prevState => ({
                        ...prevState,
                        fridayEnd :  getDayTimeArray.endArr, fridayStart :  getDayTimeArray.startArr
                    }));
                }

                if(resDayToggle.saturday == true){
                    let getDayTimeArray = slotTimeArray(resDayTime.saturdayStartDT, res.data.timeZone, resDayTime.saturdayEndDT, res.data.timeZone);

                    setTimeSlotArr(prevState => ({
                        ...prevState,
                        saturdayEnd :  getDayTimeArray.endArr, saturdayStart :  getDayTimeArray.startArr
                    }));
                }

                if(resDayToggle.sunday == true){
                    let getDayTimeArray = slotTimeArray(resDayTime.sundayStartDT, res.data.timeZone, resDayTime.sundayEndDT, res.data.timeZone);

                    setTimeSlotArr(prevState => ({
                        ...prevState,
                        sundayEnd :  getDayTimeArray.endArr, sundayStart :  getDayTimeArray.startArr
                    }));
                }

                if( resBreakToggle.monday == true){
                    let getBreakArray = breakArray(resDayTime.mondayStartDT, res.data.timeZone, resDayTime.mondayEndDT, res.data.timeZone);

                    InitialbreakArrayBySlotTime(getBreakArray, 'monday', 'mondayStart', 'mondayEnd');
                }

                if( resBreakToggle.tuesday == true){
                    let getBreakArray = breakArray(resDayTime.tuesdayStartDT, res.data.timeZone, resDayTime.tuesdayEndDT, res.data.timeZone);

                    InitialbreakArrayBySlotTime(getBreakArray, 'tuesday', 'tuesdayStart', 'tuesdayEnd');
                }

                if( resBreakToggle.wednesday == true){
                    let getBreakArray = breakArray(resDayTime.wednesdayStartDT, res.data.timeZone, resDayTime.wednesdayEndDT, res.data.timeZone);

                    InitialbreakArrayBySlotTime(getBreakArray, 'wednesday', 'wednesdayStart', 'wednesdayEnd');
                }

                if( resBreakToggle.thursday == true){
                    let getBreakArray = breakArray(resDayTime.thursdayStartDT, res.data.timeZone, resDayTime.thursdayEndDT, res.data.timeZone);

                    InitialbreakArrayBySlotTime(getBreakArray, 'thursday', 'thursdayStart', 'thursdayEnd');
                }

                if( resBreakToggle.friday == true){
                    let getBreakArray = breakArray(resDayTime.fridayStartDT, res.data.timeZone, resDayTime.fridayEndDT, res.data.timeZone);

                    InitialbreakArrayBySlotTime(getBreakArray, 'friday', 'fridayStart', 'fridayEnd');
                }

                if( resBreakToggle.saturday == true){
                    let getBreakArray = breakArray(resDayTime.saturdayStartDT, res.data.timeZone, resDayTime.saturdayEndDT, res.data.timeZone);

                    InitialbreakArrayBySlotTime(getBreakArray, 'saturday', 'saturdayStart', 'saturdayEnd');
                }

                if( resBreakToggle.sunday == true){
                    let getBreakArray = breakArray(resDayTime.sundayStartDT, res.data.timeZone, resDayTime.sundayEndDT, res.data.timeZone);

                    InitialbreakArrayBySlotTime(getBreakArray, 'sunday', 'sundayStart', 'sundayEnd');
                }
            }else{
                setPageLoader(false);
                setPageDefine('create');
            }
        }
    }

    return(
        <>
        <div>
            <Row className='CommonHeaderWrapper'>
                <Col className="stylistCommonHeader">
                    <h1>Availability</h1>
                    <p>Step 1 / 3 : Setup your availability</p>
                </Col>
            </Row>
        </div>
        {
            pageLoader === true ?
                <div style={{textAlign:'center'}}>
                    <InfinitySpin height="80" width="200" radius="9" color="#D49D29" ariaLabel="loading" wrapperStyle wrapperClass />
                </div>
            :
                <div className='booking-details availabilityII'>
                <Form onSubmit={handleSubmit} className='setting-sec'>
                    {/* All Days slots */}
                    <p className='error center'>{toggleError.checkToggle}</p>
                    <Row className='text-start'>
                        <Col>
                            <p className='availAllDay'>Let clients book online</p>
                        </Col>
                        <Col>
                            <div><ReactSwitch onColor='#D49D29' checkedIcon={false} uncheckedIcon={false} checked={dayToggle.allDay} onChange={(e) => dayToggleHandleChange(e, 'allDay')}/></div>
                        </Col>
                    </Row>
                    <Row>
                        <Form.Group as={Col} controlId="formGridMondayStart" className='availTimeZone'>
                            <Form.Label>Timezone <span>*</span></Form.Label>
                            <Form.Select aria-label="Default select example" name="timezone" value={timezone} onChange={timezoneHandleChange}>
                                <option value='US/Alaska (GMT-900)'>US/Alaska (GMT-900)</option>
                                <option value='US/Arizona (GMT-700)'>US/Arizona (GMT-700)</option>
                                <option value='US/Central (GMT-600)'>US/Central (GMT-600)</option>
                                <option value='US/Eastern (GMT-500)'>US/Eastern (GMT-500)</option>
                                <option value='US/Hawaii (GMT-1000)'>US/Hawaii (GMT-1000)</option>
                                <option value='US/Mountain (GMT-700)'>US/Mountain (GMT-700)</option>
                                <option value='US/Pacific (GMT-800)'>US/Pacific (GMT-800)</option>
                            </Form.Select>
                            <p className="error">{timezoneErr.timezone}</p>
                        </Form.Group>
                    </Row>

                    {/* Monday slots */}
                    <Row className='text-start'>
                        <hr></hr>
                        <Col>
                            <h4>Monday</h4>
                        </Col>
                        <Col>
                            <div><ReactSwitch onColor='#D49D29' checkedIcon={false} uncheckedIcon={false} checked={dayToggle.monday} onChange={(e) => dayToggleHandleChange(e, 'monday')}/></div>
                        </Col>
                        {
                            dayToggle.monday ?
                                <div>
                                    <Row>
                                        <Form.Group as={Col} controlId="formGridMondayStart">
                                            <Form.Label>Start <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="mondayStart" value={dayTime.mondayStart} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.mondayStart ?
                                                        timeSlotArr.mondayStart.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridMondayEnd">
                                            <Form.Label>End <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="mondayEnd" value={dayTime.mondayEnd} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.mondayEnd ?
                                                        timeSlotArr.mondayEnd.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <div>
                                            <Col>
                                                <p className="error">{dayError.monday}</p>
                                            </Col>
                                        </div>
                                        
                                    </Row>
                                    {
                                        breakToggle.monday ?
                                            <Row>
                                                <div>
                                                    <Col>
                                                        <h4>Break</h4>
                                                    </Col>
                                                </div>

                                                <div>
                                                    <Row>
                                                        <Form.Group as={Col} controlId="formGridMondayBreakStart">
                                                            <Form.Label>Break Start <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="mondayStart" value={breakTime.mondayStart} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.mondayStart ?
                                                                        breakSlotArr.mondayStart.map((data, index) => {
                                                                            return(
                                                                                <option value={data.value} key={index}>{data.time}</option>
                                                                            )
                                                                        })
                                                                    :
                                                                        breakArr.monday ? 
                                                                            breakArr.monday.map((data, index) => {
                                                                                if(breakArr.monday.length - 1 == index){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.monday}</p>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridMondayBreakEnd">
                                                            <Form.Label>Break End <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="mondayEnd" value={breakTime.mondayEnd} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.mondayEnd ?
                                                                        breakSlotArr.mondayEnd.map((data, index) => {
                                                                            return(
                                                                                <option value={data.value} key={index}>{data.time}</option>
                                                                            )
                                                                        })
                                                                    :
                                                                        breakArr.monday ?
                                                                            breakArr.monday.map((data, index) => {
                                                                                if(index == 0){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.monday}</p>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <p className='availRemoveBreak' onClick={() => BreakHandler(false, 'monday')}><FontAwesomeIcon icon={faTrash} /> Remove Break</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Row>
                                        :
                                            <p className='availAddBreak' onClick={() => BreakHandler(true, 'monday')}><FontAwesomeIcon icon={faCirclePlus} /> Add Break</p>
                                    }
                                </div>
                            : 
                            ''
                        }
                    </Row>

                    {/* Tuesday slots */}
                    <Row className='text-start'>
                        <hr></hr>
                        <Col>
                            <h4>Tuesday</h4>
                        </Col>
                        <Col>
                            <div><ReactSwitch onColor='#D49D29' checkedIcon={false} uncheckedIcon={false} checked={dayToggle.tuesday} onChange={(e) => dayToggleHandleChange(e, 'tuesday')}/></div>
                        </Col>
                        {
                            dayToggle.tuesday ?
                                <div>
                                    <Row>
                                        <Form.Group as={Col} controlId="formGridTuesdayStart">
                                            <Form.Label>Start <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="tuesdayStart" value={dayTime.tuesdayStart} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.tuesdayStart ?
                                                        timeSlotArr.tuesdayStart.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridtuesdayEnd">
                                            <Form.Label>End <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="tuesdayEnd" value={dayTime.tuesdayEnd} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.tuesdayEnd ?
                                                        timeSlotArr.tuesdayEnd.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <div>
                                            <Col>
                                                <p className="error">{dayError.tuesday}</p>
                                            </Col>
                                        </div>
                                        
                                    </Row>
                                    {
                                        breakToggle.tuesday ?
                                            <Row>
                                                <div>
                                                    <Col>
                                                        <h4>Break</h4>
                                                    </Col>
                                                </div>

                                                <div>
                                                    <Row>
                                                        <Form.Group as={Col} controlId="formGridtuesdayBreakStart">
                                                            <Form.Label>Break Start <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="tuesdayStart" value={breakTime.tuesdayStart} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.tuesdayStart ?
                                                                        breakSlotArr.tuesdayStart.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.tuesday ? 
                                                                            breakArr.tuesday.map((data, index) => {
                                                                                if(breakArr.tuesday.length - 1 == index){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.tuesday}</p>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridtuesdayBreakEnd">
                                                            <Form.Label>Break End <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="tuesdayEnd" value={breakTime.tuesdayEnd} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.tuesdayEnd ?
                                                                        breakSlotArr.tuesdayEnd.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.tuesday ?
                                                                            breakArr.tuesday.map((data, index) => {
                                                                                if(index == 0){
                                                                                    
                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                                
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.tuesday}</p>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <p className='availRemoveBreak' onClick={() => BreakHandler(false, 'tuesday')}><FontAwesomeIcon icon={faTrash} /> Remove Break</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Row>
                                        :
                                            <p className='availAddBreak' onClick={() => BreakHandler(true, 'tuesday')}><FontAwesomeIcon icon={faCirclePlus} /> Add Break</p>
                                    }
                                </div>
                            : 
                            ''
                        }
                    </Row>

                    {/* Wednesday slots */}
                    <Row className='text-start'>
                        <hr></hr>
                        <Col>
                            <h4>Wednesday</h4>
                        </Col>
                        <Col>
                            <div><ReactSwitch onColor='#D49D29' checkedIcon={false} uncheckedIcon={false} checked={dayToggle.wednesday} onChange={(e) => dayToggleHandleChange(e, 'wednesday')}/></div>
                        </Col>
                        {
                            dayToggle.wednesday ?
                                <div>
                                    <Row>
                                        <Form.Group as={Col} controlId="formGridwednesdayStart">
                                            <Form.Label>Start <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="wednesdayStart" value={dayTime.wednesdayStart} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.wednesdayStart ?
                                                        timeSlotArr.wednesdayStart.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridwednesdayEnd">
                                            <Form.Label>End <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="wednesdayEnd" value={dayTime.wednesdayEnd} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.wednesdayEnd ?
                                                        timeSlotArr.wednesdayEnd.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <div>
                                            <Col>
                                                <p className="error">{dayError.wednesday}</p>
                                            </Col>
                                        </div>
                                        
                                    </Row>
                                    {
                                        breakToggle.wednesday ?
                                            <Row>
                                                <div>
                                                    <Col>
                                                        <h4>Break</h4>
                                                    </Col>
                                                </div>

                                                <div>
                                                    <Row>
                                                        <Form.Group as={Col} controlId="formGridwednesdayBreakStart">
                                                            <Form.Label>Break Start <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="wednesdayStart" value={breakTime.wednesdayStart} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.wednesdayStart ?
                                                                        breakSlotArr.wednesdayStart.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.wednesday ? 
                                                                            breakArr.wednesday.map((data, index) => {
                                                                                if(breakArr.wednesday.length - 1 == index){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.wednesday}</p>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridwednesdayBreakEnd">
                                                            <Form.Label>Break End <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="wednesdayEnd" value={breakTime.wednesdayEnd} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.wednesdayEnd ?
                                                                        breakSlotArr.wednesdayEnd.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.wednesday ?
                                                                            breakArr.wednesday.map((data, index) => {
                                                                                if(index == 0){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                                
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.wednesday}</p>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <p className='availRemoveBreak' onClick={() => BreakHandler(false, 'wednesday')}><FontAwesomeIcon icon={faTrash} /> Remove Break</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Row>
                                        :
                                            <p className='availAddBreak' onClick={() => BreakHandler(true, 'wednesday')}><FontAwesomeIcon icon={faCirclePlus} /> Add Break</p>
                                    }
                                </div>
                            : 
                            ''
                        }
                    </Row>

                    {/* Thursday slots */}
                    <Row className='text-start'>
                        <hr></hr>
                        <Col>
                            <h4>Thursday</h4>
                        </Col>
                        <Col>
                            <div><ReactSwitch onColor='#D49D29' checkedIcon={false} uncheckedIcon={false} checked={dayToggle.thursday} onChange={(e) => dayToggleHandleChange(e, 'thursday')}/></div>
                        </Col>
                        {
                            dayToggle.thursday ?
                                <div>
                                    <Row>
                                        <Form.Group as={Col} controlId="formGridthursdayStart">
                                            <Form.Label>Start <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="thursdayStart" value={dayTime.thursdayStart} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.thursdayStart ?
                                                        timeSlotArr.thursdayStart.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridthursdayEnd">
                                            <Form.Label>End <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="thursdayEnd" value={dayTime.thursdayEnd} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.thursdayEnd ?
                                                        timeSlotArr.thursdayEnd.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <div>
                                            <Col>
                                                <p className="error">{dayError.thursday}</p>
                                            </Col>
                                        </div>
                                        
                                    </Row>
                                    {
                                        breakToggle.thursday ?
                                            <Row>
                                                <div>
                                                    <Col>
                                                        <h4>Break</h4>
                                                    </Col>
                                                </div>

                                                <div>
                                                    <Row>
                                                        <Form.Group as={Col} controlId="formGridthursdayBreakStart">
                                                            <Form.Label>Break Start <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="thursdayStart" value={breakTime.thursdayStart} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.thursdayStart ?
                                                                        breakSlotArr.thursdayStart.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.thursday ? 
                                                                            breakArr.thursday.map((data, index) => {
                                                                                if(breakArr.thursday.length - 1 == index){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.thursday}</p>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridthursdayBreakEnd">
                                                            <Form.Label>Break End <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="thursdayEnd" value={breakTime.thursdayEnd} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.thursdayEnd ?
                                                                        breakSlotArr.thursdayEnd.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.thursday ?
                                                                            breakArr.thursday.map((data, index) => {
                                                                                if(index == 0){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                                
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.thursday}</p>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <p className='availRemoveBreak' onClick={() => BreakHandler(false, 'thursday')}><FontAwesomeIcon icon={faTrash} /> Remove Break</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Row>
                                        :
                                            <p className='availAddBreak' onClick={() => BreakHandler(true, 'thursday')}><FontAwesomeIcon icon={faCirclePlus} /> Add Break</p>
                                    }
                                </div>
                            : 
                            ''
                        }
                    </Row>

                    {/* Friday slots */}
                    <Row className='text-start'>
                        <hr></hr>
                        <Col>
                            <h4>Friday</h4>
                        </Col>
                        <Col>
                            <div><ReactSwitch onColor='#D49D29' checkedIcon={false} uncheckedIcon={false} checked={dayToggle.friday} onChange={(e) => dayToggleHandleChange(e, 'friday')}/></div>
                        </Col>
                        {
                            dayToggle.friday ?
                                <div>
                                    <Row>
                                        <Form.Group as={Col} controlId="formGridfridayStart">
                                            <Form.Label>Start <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="fridayStart" value={dayTime.fridayStart} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.fridayStart ?
                                                        timeSlotArr.fridayStart.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridfridayEnd">
                                            <Form.Label>End <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="fridayEnd" value={dayTime.fridayEnd} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.fridayEnd ?
                                                        timeSlotArr.fridayEnd.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <div>
                                            <Col>
                                                <p className="error">{dayError.friday}</p>
                                            </Col>
                                        </div>
                                        
                                    </Row>
                                    {
                                        breakToggle.friday ?
                                            <Row>
                                                <div>
                                                    <Col>
                                                        <h4>Break</h4>
                                                    </Col>
                                                </div>

                                                <div>
                                                    <Row>
                                                        <Form.Group as={Col} controlId="formGridfridayBreakStart">
                                                            <Form.Label>Break Start <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="fridayStart" value={breakTime.fridayStart} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.fridayStart ?
                                                                        breakSlotArr.fridayStart.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.friday ? 
                                                                            breakArr.friday.map((data, index) => {
                                                                                if(breakArr.friday.length - 1 == index){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.friday}</p>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridfridayBreakEnd">
                                                            <Form.Label>Break End <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="fridayEnd" value={breakTime.fridayEnd} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.fridayEnd ?
                                                                        breakSlotArr.fridayEnd.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.friday ?
                                                                            breakArr.friday.map((data, index) => {
                                                                                if(index == 0){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                                
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.friday}</p>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <p className='availRemoveBreak' onClick={() => BreakHandler(false, 'friday')}><FontAwesomeIcon icon={faTrash} /> Remove Break</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Row>
                                        :
                                            <p className='availAddBreak' onClick={() => BreakHandler(true, 'friday')}><FontAwesomeIcon icon={faCirclePlus} /> Add Break</p>
                                    }
                                </div>
                            : 
                            ''
                        }
                    </Row>

                    {/* Saturday slots */}
                    <Row className='text-start'>
                        <hr></hr>
                        <Col>
                            <h4>Saturday</h4>
                        </Col>
                        <Col>
                            <div><ReactSwitch onColor='#D49D29' checkedIcon={false} uncheckedIcon={false} checked={dayToggle.saturday} onChange={(e) => dayToggleHandleChange(e, 'saturday')}/></div>
                        </Col>
                        {
                            dayToggle.saturday ?
                                <div>
                                    <Row>
                                        <Form.Group as={Col} controlId="formGridsaturdayStart">
                                            <Form.Label>Start <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="saturdayStart" value={dayTime.saturdayStart} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.saturdayStart ?
                                                        timeSlotArr.saturdayStart.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridsaturdayEnd">
                                            <Form.Label>End <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="saturdayEnd" value={dayTime.saturdayEnd} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.saturdayEnd ?
                                                        timeSlotArr.saturdayEnd.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <div>
                                            <Col>
                                                <p className="error">{dayError.saturday}</p>
                                            </Col>
                                        </div>
                                        
                                    </Row>
                                    {
                                        breakToggle.saturday ?
                                            <Row>
                                                <div>
                                                    <Col>
                                                        <h4>Break</h4>
                                                    </Col>
                                                </div>

                                                <div>
                                                    <Row>
                                                        <Form.Group as={Col} controlId="formGridsaturdayBreakStart">
                                                            <Form.Label>Break Start <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="saturdayStart" value={breakTime.saturdayStart} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.saturdayStart ?
                                                                        breakSlotArr.saturdayStart.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.saturday ? 
                                                                            breakArr.saturday.map((data, index) => {
                                                                                if(breakArr.saturday.length - 1 == index){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.saturday}</p>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridsaturdayBreakEnd">
                                                            <Form.Label>Break End <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="saturdayEnd" value={breakTime.saturdayEnd} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.saturdayEnd ?
                                                                        breakSlotArr.saturdayEnd.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.saturday ?
                                                                            breakArr.saturday.map((data, index) => {
                                                                                if(index == 0){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                                
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.saturday}</p>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <p className='availRemoveBreak' onClick={() => BreakHandler(false, 'saturday')}><FontAwesomeIcon icon={faTrash} /> Remove Break</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Row>
                                        :
                                            <p className='availAddBreak' onClick={() => BreakHandler(true, 'saturday')}><FontAwesomeIcon icon={faCirclePlus} /> Add Break</p>
                                    }
                                </div>
                            : 
                            ''
                        }
                    </Row>

                    {/* Sunday slots */}
                    <Row className='text-start'>
                        <hr></hr>
                        <Col>
                            <h4>Sunday</h4>
                        </Col>
                        <Col>
                            <div><ReactSwitch onColor='#D49D29' checkedIcon={false} uncheckedIcon={false} checked={dayToggle.sunday} onChange={(e) => dayToggleHandleChange(e, 'sunday')}/></div>
                        </Col>
                        {
                            dayToggle.sunday ?
                                <div>
                                    <Row>
                                        <Form.Group as={Col} controlId="formGridsundayStart">
                                            <Form.Label>Start <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="sundayStart" value={dayTime.sundayStart} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.sundayStart ?
                                                        timeSlotArr.sundayStart.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridsundayEnd">
                                            <Form.Label>End <span>*</span></Form.Label>
                                            <Form.Select aria-label="Default select example" name="sundayEnd" value={dayTime.sundayEnd} onChange={timeHandleChange}>
                                                {
                                                    timeSlotArr.sundayEnd ?
                                                        timeSlotArr.sundayEnd.map((data, index) => (
                                                            <option value={data.value} key={index}>{data.time}</option>
                                                        ))
                                                    :
                                                        timeDropDown.length > 0 ?
                                                            timeDropDown.map((data, index) => (
                                                                <option value={data.value} key={index}>{data.time}</option>
                                                            ))
                                                        : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <div>
                                            <Col>
                                                <p className="error">{dayError.sunday}</p>
                                            </Col>
                                        </div>
                                        
                                    </Row>
                                    {
                                        breakToggle.sunday ?
                                            <Row>
                                                <div>
                                                    <Col>
                                                        <h4>Break</h4>
                                                    </Col>
                                                </div>

                                                <div>
                                                    <Row>
                                                        <Form.Group as={Col} controlId="formGridsundayBreakStart">
                                                            <Form.Label>Break Start <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="sundayStart" value={breakTime.sundayStart} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.sundayStart ?
                                                                        breakSlotArr.sundayStart.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.sunday ? 
                                                                            breakArr.sunday.map((data, index) => {
                                                                                if(breakArr.sunday.length - 1 == index){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.sunday}</p>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridsundayBreakEnd">
                                                            <Form.Label>Break End <span>*</span></Form.Label>
                                                            <Form.Select aria-label="Default select example" name="sundayEnd" value={breakTime.sundayEnd} onChange={breakHandleChange}>
                                                                {
                                                                    breakSlotArr.sundayEnd ?
                                                                        breakSlotArr.sundayEnd.map((data, index) => (
                                                                            <option value={data.value} key={index}>{data.time}</option>
                                                                        ))
                                                                    :
                                                                        breakArr.sunday ?
                                                                            breakArr.sunday.map((data, index) => {
                                                                                if(index == 0){

                                                                                }else{
                                                                                    return(
                                                                                        <option value={data.value} key={index}>{data.time}</option>
                                                                                    )
                                                                                }
                                                                                
                                                                            })
                                                                        :
                                                                        ''
                                                                }
                                                            </Form.Select>
                                                            <p className="error">{breakError.sunday}</p>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <p className='availRemoveBreak' onClick={() => BreakHandler(false, 'sunday')}><FontAwesomeIcon icon={faTrash} /> Remove Break</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Row>
                                        :
                                            <p className='availAddBreak' onClick={() => BreakHandler(true, 'sunday')}><FontAwesomeIcon icon={faCirclePlus} /> Add Break</p>
                                    }
                                </div>
                            : 
                            ''
                        }
                    </Row>

                    {/* Form on submit */}
                    <Row>
                        {
                            spinLoader === true ?
                                <div style={{textAlign:'center'}}>
                                    <InfinitySpin height="80" width="200" radius="9" color="#D49D29" ariaLabel="loading" wrapperStyle wrapperClass />
                                </div>
                            :
                                <Col style={{textAlign : 'center'}} className='stylistCommonBtn'>
                                    <Button variant="dark" className='upload-btn' type='submit'>Next</Button>
                                </Col>
                        }
                    </Row>
                </Form>
                </div>
        }
        </>
    )
} 